import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";

const TOKEN_KEY = "AuthTokenWeb"+environment.name;

@Injectable({
	providedIn: "root",
})
export class AuthenticationService {
	public authenticationState = new BehaviorSubject("");

	constructor(private router: Router) {
		this.checkToken();
	}

	/**
	 * Verificar si existe token de sesión
	 */
	public checkToken() {
		let res = localStorage.getItem(TOKEN_KEY);
		if (res) {
			this.authenticationState.next(res);
		}
	}

	public getToken(){
		return JSON.parse(localStorage.getItem(TOKEN_KEY));
	}

	public getUser(){
		return JSON.parse(localStorage.getItem("dataUserWeb"));
	}

	/**
	 * Asignar token de sesión al almacenamiento local
	 * @param token
	 * @returns
	 */
	public login(token: any) {
		this.authenticationState.next(token);
		return localStorage.setItem(TOKEN_KEY, token);
	}

	/**
	 * Cerrar sesión y eliminar token almacenado
	 * @returns
	 */
	public logout() {
		this.authenticationState.next("logout");
		return localStorage.removeItem(TOKEN_KEY);
	}

	/**
	 * Devolver valor actual del token de sesión
	 * @returns
	 */
	public isAuthenticated() {
		return this.authenticationState.value;
	}
}
